import { BaseSyntheticEvent } from "react";
import { userExistsByEmail } from "@/app/FintreeAPI";

export function getEmailValidationPattern() {
  return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
}

export const checkEmail = (event: BaseSyntheticEvent) => {
  const email = event.target.value;

  return getEmailValidationPattern().test(email);
};

export const checkEmailValidAndNotExists = async (
  event: BaseSyntheticEvent,
  existsCallback: () => void,
  isValidCallback: () => void,
) => {
  const email = event.target.value;
  const emailExists = await userExistsByEmail(email).then((response) => {
    return response.status === 200;
  });

  if (emailExists) {
    existsCallback();
  }

  const valid = getEmailValidationPattern().test(email) && !emailExists;

  if (valid) {
    isValidCallback();
  }

  return valid;
};

export function getPasswordValidationPattern() {
  /*
      at least 1 lower case letter
      at least 1 capital letter
      at least 1 number
      at least 1 special character
      at least 8 characters
   */
  return /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8}$/;
}

export function passwordHasAnUpperCaseCharacter(password: string) {
  return password.match(/^(?=.*[A-Z]).*$/);
}

export function passwordHasALowerCaseCharacter(password: string) {
  return password.match(/^(?=.*[a-z]).*$/);
}

export function passwordHasANumber(password: string) {
  return password.match(/^(?=.*[0-9]).*$/);
}

export function passwordHasASpecialCharacter(password: string) {
  return password.match(/^(?=.*\W)(?!.* ).*$/);
}

export function passwordHasAtLeastNCharacters(password: string, n: number) {
  const regex = new RegExp(`^(?!.* ).{${n},}$`);
  return password.match(regex);
}

interface PasswordValidationEntry {
  rule: RegExp;
  message: string;
}

interface ValidatePasswordParams {
  minChars: Number;
}

export function hookFormValidatePassword(params: ValidatePasswordParams) {
  const { minChars } = params;

  const rules: Array<PasswordValidationEntry> = [
    { rule: /^(?=.*[A-Z]).*$/, message: "Should contain at least an uppercase letter" },
    { rule: /^(?=.*[a-z]).*$/, message: "Should contain at least a lowercase letter" },
    { rule: /^(?=.*[0-9]).*$/, message: "Should contain at least a number" },
    { rule: /^(?=.*\W)(?!.* ).*$/, message: "Should contain at least a special character" },
    { rule: new RegExp(`^(?!.* ).{${minChars},}$`), message: `Should contain at least ${minChars} characters` },
  ];

  return rules.reduce((acc, { rule, message }, idx) => {
    return { ...acc, [idx]: (value: string) => rule.test(value) || message };
  }, {});
}

// export function usePasswordValidation(minChars: Number) {
//   const RulesMap: Array<PasswordValidationEntry> = [
//     { rule: /^(?=.*[A-Z]).*$/, error: "Should contain at least an uppercase letter" },
//     { rule: /^(?=.*[a-z]).*$/, error: "Should contain at least a lowercase letter" },
//     { rule: /^(?=.*[0-9]).*$/, error: "Should contain at least a number" },
//     { rule: /^(?=.*\W)(?!.* ).*$/, error: "Should contain at least a special character" },
//     { rule: new RegExp(`^(?!.* ).{${minChars},}$`), error: `Should contain at least ${minChars} characters` }
//   ];
//
//   const isValid = (value: string = "") => RulesMap.filter(({ rule }) => !value.match(rule)).length === 0;
//   const getErrors = (value: string = "") => RulesMap.filter(({ rule }) => !value.match(rule)).map(rule => rule.error);
//
//   return [isValid, getErrors];
// }
